import Loading from "vue-loading-overlay";
import $ from 'jquery';

export default {
    name: "SellYourDevice",
    components: {
        Loading
    },
    data() {
        localStorage.removeItem("ChooseSoldDeviceCategory");
        localStorage.removeItem("ChooseDevice");
        localStorage.removeItem("deviceImage");
        localStorage.removeItem("ChooseDeviceCondition");
        localStorage.removeItem("ChooseDeviceCarrier");
        localStorage.removeItem("ChooseDeviceStroage");
        localStorage.removeItem("ChooseDeviceOperation");
        //localStorage.removeItem("cart");
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            cmsData: [],
            menuText: "Choose Category",
            categoryImagePath: this.$api+"assets/sell/device/category/",
            deviceImagePath: this.$api+"assets/sell/device/category-device/",
            allDeviceDataList: [], 
            deviceConditionObject: [], 
            deviceCarrierObject: [], 
            deviceStroageObject: [], 
            deviceOperationObject: [],
            getAllServiceOptions:[],
            sellDeviceCart:{items:[],total_quantity:0,total_price:0},
            sellDeviceCartString:'',
            cartServerResponse:'',
            deviceCategoryArea: true,
            deviceInfoArea: false,
            deviceConditionaArea: false,
            deviceCarierArea: false,
            deviceStroageArea: false,
            deviceOperationArea: false,
            conditionRulesArea: false,
            deviceSummaryArea: false,
            deviceInfoClassArea: '',
            deviceConditionaClassArea: '',
            deviceCarrierClassArea: '',
            deviceStroageClassArea: '',
            deviceOperationClassArea: '',
            deviceConditionRules: '',
            deviceConditionRulesDetail: '',
            notGetAllServiceOptionsDataText: '',
            deviceEstPriceValueAt: 0,
            mySellCart:0,

            ChooseSoldDeviceCategory:localStorage.getItem('ChooseSoldDeviceCategory')=== null?'Choose Category':localStorage.getItem('ChooseSoldDeviceCategory'),
            ChooseDevice:localStorage.getItem('ChooseDevice')=== null?'Device':localStorage.getItem('ChooseDevice'),
            deviceImage:localStorage.getItem('deviceImage')=== null?'':localStorage.getItem('deviceImage'),
            ChooseDeviceCondition:localStorage.getItem('ChooseDeviceCondition')=== null?'Condition':localStorage.getItem('ChooseDeviceCondition'),
            ChooseDeviceCarrier:localStorage.getItem('ChooseDeviceCarrier')=== null?'Carrier':localStorage.getItem('ChooseDeviceCarrier'),
            ChooseDeviceStroage:localStorage.getItem('ChooseDeviceStroage')=== null?'Storage':localStorage.getItem('ChooseDeviceStroage'),
            ChooseDeviceOperation:localStorage.getItem('ChooseDeviceOperation')=== null?'Operational':localStorage.getItem('ChooseDeviceOperation'),
        }
    },
    mounted() {
        localStorage.removeItem("ChooseSoldDeviceCategory");
        localStorage.removeItem("ChooseDevice");
        localStorage.removeItem("deviceImage");
        localStorage.removeItem("ChooseDeviceCondition");
        localStorage.removeItem("ChooseDeviceCarrier");
        localStorage.removeItem("ChooseDeviceStroage");
        localStorage.removeItem("ChooseDeviceOperation");
        localStorage.removeItem("deviceConditionRules");
        localStorage.removeItem("deviceConditionRulesDetail");
        localStorage.removeItem("device_operation_id");
    },
    created() {
        this.getAllService();
        this.loadDeviceCategory();

        localStorage.removeItem("ChooseSoldDeviceCategory");
        localStorage.removeItem("ChooseDevice");
        localStorage.removeItem("deviceImage");
        localStorage.removeItem("ChooseDeviceCondition");
        localStorage.removeItem("ChooseDeviceCarrier");
        localStorage.removeItem("ChooseDeviceStroage");
        localStorage.removeItem("ChooseDeviceOperation");
        localStorage.removeItem("deviceConditionRules");
        localStorage.removeItem("deviceConditionRulesDetail");
        localStorage.removeItem("device_operation_id");
    },
    methods: {
        getAllService: function() {
            this.isLoading = true;
            var config = {
                method: "GET",
                url: this.$api + "api/all-service"
            };
            this.$axios(config).then((response) => {
                if(response.data.status == "success") {
                    this.cmsData = response.data.data;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        loadDeviceCategory: function() {
            localStorage.removeItem("ChooseSoldDeviceCategory");
            localStorage.removeItem("ChooseDevice");
            localStorage.removeItem("deviceImage");
            localStorage.removeItem("ChooseDeviceCondition");
            localStorage.removeItem("ChooseDeviceCarrier");
            localStorage.removeItem("ChooseDeviceStroage");
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("deviceConditionRules");
            localStorage.removeItem("deviceConditionRulesDetail");
            localStorage.removeItem("device_operation_id");

            this.ChooseSoldDeviceCategory = localStorage.getItem('ChooseSoldDeviceCategory') === null ? 'Choose Category': localStorage.getItem('ChooseSoldDeviceCategory');
            this.ChooseDevice = localStorage.getItem('ChooseDevice') === null ? 'Device': localStorage.getItem('ChooseDevice');
            this.deviceImage = localStorage.getItem('deviceImage') === null ? '': localStorage.getItem('deviceImage');
            this.ChooseDeviceCondition = localStorage.getItem('ChooseDeviceCondition') === null ? 'Condition':localStorage.getItem('ChooseDeviceCondition');
            this.ChooseDeviceCarrier = localStorage.getItem('ChooseDeviceCarrier') === null? 'Carrier': localStorage.getItem('ChooseDeviceCarrier');
            this.ChooseDeviceStroage = localStorage.getItem('ChooseDeviceStroage') === null? 'Storage': localStorage.getItem('ChooseDeviceStroage');
            this.ChooseDeviceOperation = localStorage.getItem('ChooseDeviceOperation') === null? 'Operational': localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea = true;
            this.deviceInfoArea = false;
            this.deviceConditionaArea = false;
            this.deviceCarierArea = false;
            this.deviceStroageArea = false;
            this.deviceOperationArea = false;
            this.conditionRulesArea = false;
            this.deviceSummaryArea = false;
            this.deviceInfoClassArea = '';
            this.deviceConditionaClassArea = '';
            this.deviceCarrierClassArea = '';
            this.deviceStroageClassArea = '';
            this.deviceOperationClassArea = '';
            this.getDeviceInfo();
        },
        getDeviceInfo: function() {
            this.menuText = "Choose Your Device";
            this.isLoading = true;
            let device_category = localStorage.getItem("device_category");
            this.$axios.get(this.$api + 'api/device-list/' + device_category).then(response => {
                this.allDeviceDataList = response.data.data;
                this.isLoading = false;
            }).catch(error=> {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        navDeviceInfo(){
            this.menuText = "Choose Your Device";
            if(this.ChooseDevice == "Device")
            {
                return false;
            }
            localStorage.removeItem("ChooseDevice");
            localStorage.removeItem("deviceImage");
            localStorage.removeItem("ChooseDeviceCondition");
            localStorage.removeItem("ChooseDeviceCarrier");
            localStorage.removeItem("ChooseDeviceStroage");
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("deviceConditionRules");
            localStorage.removeItem("deviceConditionRulesDetail");
            localStorage.removeItem("device_operation_id");

            this.ChooseDevice = localStorage.getItem('ChooseDevice') === null ? 'Device': localStorage.getItem('ChooseDevice');
            this.deviceImage = localStorage.getItem('deviceImage') === null ? '': localStorage.getItem('deviceImage');
            this.ChooseDeviceCondition = localStorage.getItem('ChooseDeviceCondition') === null ? 'Condition': localStorage.getItem('ChooseDeviceCondition');
            this.ChooseDeviceCarrier = localStorage.getItem('ChooseDeviceCarrier') === null ? 'Carrier': localStorage.getItem('ChooseDeviceCarrier');
            this.ChooseDeviceStroage = localStorage.getItem('ChooseDeviceStroage') === null ? 'Storage': localStorage.getItem('ChooseDeviceStroage');
            this.ChooseDeviceOperation = localStorage.getItem('ChooseDeviceOperation') === null ? 'Operational': localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea = false;
            this.deviceInfoArea = true;
            this.deviceConditionaArea = false;
            this.deviceCarierArea = false;
            this.deviceStroageArea = false;
            this.deviceOperationArea = false;
            this.conditionRulesArea = false;
            this.deviceSummaryArea = false;
            this.deviceInfoClassArea = 'active';
            this.deviceConditionaClassArea = '';
            this.deviceCarrierClassArea = '';
            this.deviceStroageClassArea = '';
            this.deviceOperationClassArea = '';
            this.getDeviceOtherInfo();
            this.deviceCarrierObject = []; 
            this.deviceStroageObject = []; 
            this.deviceOperationObject = []; 
        },
        getDeviceOtherInfo() {
            this.menuText = "Choose Your Device Condition";
            this.isLoading = true;
            let device_category = localStorage.getItem("device_category");
            let device_id = localStorage.getItem("device_id");
            this.$axios.get(this.$api + 'api/device-condition/' + device_category + '/' + device_id).then(response => {
                this.deviceConditionObject = response.data.data.DeviceCondition;
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        navConditionInfo(){
            if(this.ChooseDeviceCondition == "Condition")
            {
                return false;
            }
            localStorage.removeItem("ChooseDeviceCondition");
            localStorage.removeItem("ChooseDeviceCarrier");
            localStorage.removeItem("ChooseDeviceStroage");
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("deviceConditionRules");
            localStorage.removeItem("deviceConditionRulesDetail");
            localStorage.removeItem("device_operation_id");

            this.ChooseDeviceCondition=localStorage.getItem('ChooseDeviceCondition')=== null?'Condition':localStorage.getItem('ChooseDeviceCondition');
            this.ChooseDeviceCarrier=localStorage.getItem('ChooseDeviceCarrier')=== null?'Carrier':localStorage.getItem('ChooseDeviceCarrier');
            this.ChooseDeviceStroage=localStorage.getItem('ChooseDeviceStroage')=== null?'Storage':localStorage.getItem('ChooseDeviceStroage');
            this.ChooseDeviceOperation=localStorage.getItem('ChooseDeviceOperation')=== null?'Operational':localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea=false;
            this.deviceInfoArea=false;
            this.deviceConditionaArea=true;
            this.deviceCarierArea=false;
            this.deviceStroageArea=false;
            this.deviceOperationArea=false;
            this.conditionRulesArea=false;
            this.deviceSummaryArea=false;

            this.getDeviceOtherInfo();

            this.deviceConditionaClassArea='active';
            this.deviceCarrierClassArea='';
            this.deviceStroageClassArea='';
            this.deviceOperationClassArea='';

            this.deviceCarrierObject=[];
            this.deviceStroageObject=[]; 
            this.deviceOperationObject=[]; 
        },
        navCarrierInfo(){
            if(this.ChooseDeviceCarrier == "Carrier")
            {
                return false;
            }
            localStorage.removeItem("ChooseDeviceCarrier");
            localStorage.removeItem("ChooseDeviceStroage");
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("deviceConditionRules");
            localStorage.removeItem("deviceConditionRulesDetail");
            localStorage.removeItem("device_operation_id");
            localStorage.removeItem("device_carrier_id");

            this.ChooseDeviceCarrier=localStorage.getItem('ChooseDeviceCarrier')=== null?'Carrier':localStorage.getItem('ChooseDeviceCarrier');
            this.ChooseDeviceStroage=localStorage.getItem('ChooseDeviceStroage')=== null?'Storage':localStorage.getItem('ChooseDeviceStroage');
            this.ChooseDeviceOperation=localStorage.getItem('ChooseDeviceOperation')=== null?'Operational':localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea=false;
            this.deviceInfoArea=false;
            this.deviceConditionaArea=false;
            this.deviceCarierArea=true;
            this.deviceStroageArea=false;
            this.deviceOperationArea=false;
            this.conditionRulesArea=false;
            this.deviceSummaryArea=false;
            this.deviceStroageArea=false;

            this.getDeviceCarrierInfo();

            this.deviceCarrierClassArea='active';
            this.deviceStroageClassArea='';
            this.deviceOperationClassArea='';

            this.deviceStroageObject=[];
            this.deviceOperationObject=[];

        },
        getDeviceCarrierInfo() {
            this.mobileMenuText = "Choose Your Device Carrier";
            this.isLoading = true;
            let device_category = localStorage.getItem("device_category");
            let device_id = localStorage.getItem("device_id");
            this.$axios.get(this.$api + 'api/device-carrier/' + device_category + '/' + device_id).then(response => {
                this.deviceCarrierObject = response.data.data;
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "Something went wrong. Please try again!"
                });
            });
        },
        navStroageInfo(){
            if(this.ChooseDeviceStroage == "Stroage")
            {
                return false;
            }
            localStorage.removeItem("ChooseDeviceStroage");
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("deviceConditionRules");
            localStorage.removeItem("deviceConditionRulesDetail");
            localStorage.removeItem("device_operation_id");

            this.ChooseDeviceStroage=localStorage.getItem('ChooseDeviceStroage')=== null?'Storage':localStorage.getItem('ChooseDeviceStroage');
            this.ChooseDeviceOperation=localStorage.getItem('ChooseDeviceOperation')=== null?'Operational':localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea=false;
            this.deviceInfoArea=false;
            this.deviceConditionaArea=false;
            this.deviceCarierArea=false;
            this.deviceStroageArea=true;
            this.deviceOperationArea=false;
            this.conditionRulesArea=false;
            this.deviceSummaryArea=false;

            this.getDeviceStroageInfo();
            this.deviceStroageClassArea='active';
            this.deviceOperationClassArea='';
            this.deviceOperationObject=[]; 
        },
        getDeviceStroageInfo() {
            this.menuText = "Choose Your Device Stroage";
            this.isLoading = true;
            let device_category = localStorage.getItem("device_category");
            let device_id = localStorage.getItem("device_id");
            this.$axios.get(this.$api + 'api/device-stroage/' + device_category + '/' + device_id).then(response => {
                this.deviceStroageObject = response.data.data;
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        navOpertionInfo(){
            if(this.ChooseDeviceOperation == "Operational")
            {
                return false;
            }
            localStorage.removeItem("ChooseDeviceOperation");
            localStorage.removeItem("device_operation_id");

            this.ChooseDeviceOperation=localStorage.getItem('ChooseDeviceOperation')=== null?'Operational':localStorage.getItem('ChooseDeviceOperation');

            this.deviceCategoryArea=false;
            this.deviceInfoArea=false;
            this.deviceConditionaArea=false;
            this.deviceCarierArea=false;
            this.deviceStroageArea=false;
            this.deviceOperationArea=true;
            this.conditionRulesArea=false;
            this.deviceSummaryArea=false;

            this.getDeviceOperationInfo();
            this.deviceOperationClassArea='active';
        },
        getDeviceOperationInfo() {
            this.menuText = "Choose Device Operational?";
            this.isLoading = true;
            let device_category = localStorage.getItem("device_category");
            let device_id = localStorage.getItem("device_id");
            this.$axios.get(this.$api + 'api/device-operation/' + device_category + '/' + device_id)
            .then(response => {
                this.deviceOperationObject = response.data.data;
                this.isLoading = false;
            })
            .catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        choosenSoldCategory(soldCategory){
            localStorage.setItem("device_category", soldCategory);
            this.cmsData.device_category.forEach((key, row) => {
                console.log(key, row);
                if(soldCategory == key.id)
                {
                    localStorage.setItem('ChooseSoldDeviceCategory', key.name);
                }
            });

            this.ChooseSoldDeviceCategory = localStorage.getItem('ChooseSoldDeviceCategory');
            this.deviceInfoArea = true;
            this.deviceCategoryArea = false;
            this.getDeviceInfo();
            this.deviceInfoClassArea = 'active';
            this.getFunctionScrollToSellBox();
        },
        choosenSoldDevice(soldDevice){
            localStorage.setItem("device_id", soldDevice);
            this.allDeviceDataList.forEach((key, row) => {
                console.log(key, row);
                if(soldDevice == key.id)
                {
                    localStorage.setItem('ChooseDevice', key.name);
                    localStorage.setItem('deviceImage', key.image);
                }
            });

            this.ChooseDevice = localStorage.getItem('ChooseDevice');
            this.deviceImage = localStorage.getItem('deviceImage');
            this.deviceConditionaClassArea = 'active';

            this.getDeviceOtherInfo();
            this.deviceInfoArea = false;
            this.deviceConditionaArea = true;
            this.getFunctionScrollToSellBox();
        },
        choosenDeviceCondition(deviceCondition){
            localStorage.setItem("device_condition_id", deviceCondition);
            this.deviceConditionObject.forEach((key, row) => {
                console.log(key, row);
                if(deviceCondition == key.id)
                {
                    localStorage.setItem('ChooseDeviceCondition',key.name);
                    localStorage.setItem('deviceConditionRules',key.condition_rules_title);
                    localStorage.setItem('deviceConditionRulesDetail',key.condition_rules);
                }
            });

            this.ChooseDeviceCondition = localStorage.getItem('ChooseDeviceCondition');
            this.deviceConditionRules = localStorage.getItem('deviceConditionRules');
            this.deviceConditionRulesDetail = JSON.parse(localStorage.getItem('deviceConditionRulesDetail'));
            this.conditionRulesArea = true;
            this.getFunctionScrollToConditionBelow();
        },
        choosenDeviceCarrier(deviceCarrier){
            localStorage.setItem("device_carrier_id", deviceCarrier);
            this.deviceCarrierObject.forEach((key, row) => {
                console.log(key, row);
                if(deviceCarrier == key.id)
                {
                    localStorage.setItem('ChooseDeviceCarrier',key.name);
                }
            });

            this.deviceStroageArea=false;
            this.deviceOperationArea=false;
            this.conditionRulesArea=false;
            this.deviceSummaryArea=false;

            this.ChooseDeviceCarrier = localStorage.getItem('ChooseDeviceCarrier');
            this.deviceStroageClassArea = 'active';
            this.getDeviceStroageInfo();
            this.deviceInfoArea = false;
            this.deviceCarierArea = false;
            this.deviceStroageArea = true;
            this.getFunctionScrollToSellBox();
        },
        choosenDeviceStroage(deviceStroage){
            localStorage.setItem("device_stroage_id", deviceStroage);
            this.deviceStroageObject.forEach((key, row) => {
                console.log(key, row);
                if(deviceStroage == key.id)
                {
                    localStorage.setItem('ChooseDeviceStroage',key.name);
                }
            });

            this.ChooseDeviceStroage = localStorage.getItem('ChooseDeviceStroage');
            this.deviceOperationClassArea = 'active';
            this.getDeviceOperationInfo();
            this.deviceStroageArea = false;
            this.deviceOperationArea = true;
            this.getFunctionScrollToSellBox();
        },
        choosenDeviceOperation(deviceOperation){
            localStorage.setItem("device_operation_id", deviceOperation);
            this.deviceOperationObject.forEach((key, row) => {
                console.log(key, row);
                if(deviceOperation == key.id)
                {
                    localStorage.setItem('ChooseDeviceOperation',key.name);
                }
            });
            this.ChooseDeviceOperation = localStorage.getItem('ChooseDeviceOperation');
            this.deviceOperationArea = false;
            this.deviceSummaryArea = true;

            this.getDeviceEstimatedPrice();
            this.getFunctionScrollToSellBox();

            var i;
            console.log("local storage");
            for (i = 0; i < localStorage.length; i++)   {
                console.log(localStorage.key(i) + "=[" + localStorage.getItem(localStorage.key(i)) + "]");
            }
        },
        findCartIndex(values, cartID){
            let selectedIndex;
            const valuePresent = values.some((value, index) => {
              selectedIndex = index;
              return value === cartID;
            });
            return valuePresent ? selectedIndex : -1;
        },
        getDeviceEstimatedPrice() {
            this.menuText="Your Device Estimated Price";
            this.isLoading = true;
            let formData = new FormData();
            formData.append('device_id', localStorage.getItem('device_id'));
            formData.append('device_condition_id', localStorage.getItem('device_condition_id'));
            formData.append('device_carrier_id', localStorage.getItem('device_carrier_id'));
            formData.append('device_stroage_id', localStorage.getItem('device_stroage_id'));
            formData.append('device_operation_id', localStorage.getItem('device_operation_id'));

            this.$axios.post(this.$api + "api/device-price", formData)
            .then(response => {
                let estmatedPriceJson = response.data.data;
                if(estmatedPriceJson.device_record > 0)
                {
                    this.deviceEstPriceValueAt = estmatedPriceJson.estimated_price.total_price;
                    this.deviceEstPriceValueAt = parseFloat(this.deviceEstPriceValueAt).toFixed(2);
                    console.log('this.deviceEstPriceValueAt = ',this.deviceEstPriceValueAt);
                }
                this.isLoading = false;
            })
            .catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        addToDeviceSell(){
            this.getAddToSellBoxCart();
        },
        getloadCart: function() {
            this.isLoading = true;
            this.$axios.get(this.$api + 'cart-api/load-cart').then(response => {
                console.log(response.data);
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            })
        },
        
        getAddToSellBoxCart() {
            let formData = new FormData();
            formData.append('device_id', localStorage.getItem('device_id'));
            formData.append('device_condition_id', localStorage.getItem('device_condition_id'));
            formData.append('device_carrier_id', localStorage.getItem('device_carrier_id'));
            formData.append('device_stroage_id', localStorage.getItem('device_stroage_id'));
            formData.append('device_operation_id', localStorage.getItem('device_operation_id'));
            formData.append('device_image', localStorage.getItem('deviceImage'));
            //this.sellDeviceCart
            const cartID=localStorage.getItem('device_id')+localStorage.getItem('device_condition_id')+localStorage.getItem('device_carrier_id')+localStorage.getItem('device_stroage_id')+localStorage.getItem('device_operation_id');
            
            if(localStorage.getItem('cart'))
            {
                console.log('Before Parse ',localStorage.getItem('cart'));
                if(localStorage.getItem('cart')==null)
                {
                    this.sellDeviceCart.total_price=0;
                    this.sellDeviceCart.total_quantity=0;
                    this.sellDeviceCart.items=[];

                    this.sellDeviceCartString=JSON.stringify(this.sellDeviceCart);
                    console.log('Type of object = ',typeof(this.sellDeviceCartString));

                    localStorage.setItem('cart',this.sellDeviceCartString);
                }
                else
                {
                    if(localStorage.getItem('cart').length>0)
                    {
                        let oldCart=JSON.parse(localStorage.getItem('cart'));
                        console.log('oldCart = ',oldCart);
                        if(oldCart!=null)
                        {
                            if(oldCart.items!== undefined)
                            {
                                this.sellDeviceCart=oldCart;
                                console.log("Local Stroage Not Empty");
                                console.log(oldCart.items);
                            }
                            else
                            {
                                console.log("Local Stroage Empty");
                            }
                        }
                        else
                        {
                            this.sellDeviceCart.total_price=0;
                            this.sellDeviceCart.total_quantity=0;
                            this.sellDeviceCart.items=[];

                            this.sellDeviceCartString=JSON.stringify(this.sellDeviceCart);
                            console.log('Type of object = ',typeof(this.sellDeviceCartString));

                            localStorage.setItem('cart',this.sellDeviceCartString);
                        }
                        
                    }
                    else
                    {
                        console.log("Local Stroage Empty");
                    }
                }
                
                
            }
            else
            {
                this.sellDeviceCart.total_price=0;
                this.sellDeviceCart.total_quantity=0;
                this.sellDeviceCart.items=[];

                this.sellDeviceCartString=JSON.stringify(this.sellDeviceCart);
                console.log('Type of object = ',typeof(this.sellDeviceCartString));

                localStorage.setItem('cart',this.sellDeviceCartString);
            }


            //console.log('this.sellDeviceCart = ',this.sellDeviceCart);
            //console.log('this.sellDeviceCart = ',this.sellDeviceCart.items);
            console.log('this.sellDeviceCart = ',cartID);

            //this.sellDeviceCart={items:[],total_quantity:0,total_price:0};
            if(this.sellDeviceCart.length>0)
            {
                const check = this.sellDeviceCart.items.filter(item => item.cart_id===cartID); 
                if(check.length > 0){
                    console.log('Item is already available');
                }
            }
            else
            {
                this.sellDeviceCart={items:[],total_quantity:0,total_price:0};
            }
            console.log(this.sellDeviceCart);
            //return false;

            

            this.$axios.post(this.$api + "cart-api/add-to-sell-box", formData).then(response => {
                
                this.cartServerResponse = response.data;
                let data = response.data;
                console.log(this.cartServerResponse)
                let cartOld={};
                let checkStatus=[];
                let checkStatusIndex=null;
                console.log('Axios Local= ',localStorage.getItem('cart'));
                if(localStorage.getItem('cart').length>0)
                {
                    console.log('Session checking = ');
                    cartOld=JSON.parse(localStorage.getItem('cart'));
                    let oldCartItem=cartOld.items;
                    if(oldCartItem.length > 0)
                    {
                        checkStatus=oldCartItem.filter(item => item.cart_id==cartID);
                        console.log('Session Filter = ',checkStatus.length);
                        oldCartItem.forEach((t,index)=>{
                            console.log('Looping = ',t, index);
                            if(t.cart_id==cartID)
                            {
                                checkStatusIndex=index;
                            }
                        });
                    }
                }

                

                
        // console.log(index)

                console.log('Item Index Found = ',checkStatusIndex);

                console.log('checkStatus = ',checkStatus);
                if(checkStatus.length > 0){
                    
                    console.log('Item found on filter');
                    cartOld.total_price+=data.estimated_price;
                    cartOld.total_quantity++;
                    cartOld.items[checkStatusIndex].qty++;
                    cartOld.items[checkStatusIndex].price+=data.estimated_price;
                }
                else
                {
                    console.log('Item not found on filter');
                        console.log('cartOld = ', cartOld);

                        if(cartOld.items==0)
                        {
                            cartOld.items=[];
                        }

                        cartOld.items.push({
                            'cart_id':data.cart_id,
                            'name':data.product_name,
                            'unit_price':data.estimated_price,
                            'price':data.estimated_price,
                            'qty':1,
                            'deviceImage':this.deviceImage,
                            'item':data.product
                        });
                        cartOld.total_price+=data.estimated_price;
                        cartOld.total_quantity++;
                }

                this.sellDeviceCartString=JSON.stringify(cartOld);
                console.log('Type of object = ',typeof(this.sellDeviceCartString));

                localStorage.setItem('cart',this.sellDeviceCartString);
                console.log('this.sellDeviceCart Updated=',this.sellDeviceCartString);
                console.log('this.sellDeviceCart stroiage=',localStorage.getItem('cart'));

                this.sellDeviceCart = cartOld;

                console.log('Cart Items: ', this.sellDeviceCart);
                this.mySellCart = cartOld.total_quantity;
                this.$emit('updateMySellCart', cartOld.total_quantity);
                this.loadStatus = true;
                //this.$store.state.pageLoader = false;

                

                this.$router.push({name: 'Cart'});
                //this.getloadCart();
            })
            .catch(e => {
                console.log(e);
            });

            console.log(this.cartServerResponse);
        },
        nextDeviceCondition(){
            this.deviceCarrierClassArea = 'active';
            this.getDeviceCarrierInfo();
            this.deviceInfoArea = false;
            this.deviceConditionaArea = false;
            this.deviceCarierArea = true;
            this.getFunctionScrollToSellBox();
        },
        getFunctionScrollToSellBox: function() {
            $('html, body').animate({scrollTop: $('#service_top_sell_device').offset().top - 50 }, 'fast');
        },
        getFunctionScrollToConditionBelow() {
           // $('html, body').animate({scrollTop: $('#deviceConditionaArea').offset().top + 130 }, 'fast');
        },
    }
} 